import SetCameraTarget from "../../SetCameraTarget";
import { Ebbne, MountWithEbbne, useEbbne } from "@solidwhite/ebbnen";
import { UIPortal } from "@solidwhite/ui-portal";
import SideBar from "../../../ui/SideBar/SideBar";
import { useGLTF } from "@react-three/drei";
import EbbnenLabel from "../../EbbnenLabel";
import { GreenGrid } from "../../effects/GreenGrid";
import { WeldacMeasurementLines } from "./WeldacMeasurementLines";
import React, { useEffect } from "react";
import { MathUtils, Vector3 } from "three";
import { useDracoGLTF } from "@utils";
import EnvironmentRotationSetter from "../../EnvironmentRotationSetter";

const familyMemberMap = {
  "weldac-11": ["IMC11", "Rectified_Unit"],
  "weldac-22": ["IMC22", "Rectified_Unit_(1)", "Rectified_Unit_(2)"],
  "weldac-03": ["W03"],
  "weldac-04": ["W04"],
  "weldac-06": ["W06", "Weldac06_2T"],
  "weldac-08": ["W08", "Weldac08_2T"],
};

export const WeldacFamily = () => {
  const { nodes, scene, animations } = useGLTF("./models/heat/Weldac_Family.glb", "./draco/gltf/");
  const { ebbneId } = useEbbne();

  return (
    <>
      <MountWithEbbne>
        <SetCameraTarget settingsObject={nodes.CameraTarget_01} />
        <primitive object={nodes["Weldac_People"]} />

        <UIPortal>
          <SideBar key={`Sidebar_${ebbneId}`} contentId={"weldac-family"} />
        </UIPortal>

        <EnvironmentRotationSetter yRotation={-65} />
      </MountWithEbbne>

      <MountWithEbbne mountedWhen="active-and-below">
        <GreenGrid position={[0, 0, 0]} cellSize={0.4} sectionSize={2} fadeDistance={200} fadeStrength={10} />
      </MountWithEbbne>

      <group>
        {Object.entries(familyMemberMap).map(([routeName, nodeNames]) => (
          <Ebbne id={routeName} visibleWithAbove={1} key={routeName}>
            <FamilyMember nodeNames={nodeNames} nodes={nodes} />
          </Ebbne>
        ))}
      </group>
    </>
  );
};

useDracoGLTF.preload("./models/heat/Weldac_Family.glb");

const FamilyMember = ({ nodeNames, nodes }: { nodeNames: string[]; nodes: any }) => {
  const { ebbneId } = useEbbne();

  return (
    <>
      {nodes[`Label_${nodeNames[0]}`] && <EbbnenLabel hotspot={nodes[`Label_${nodeNames[0]}`]} />}

      <MountWithEbbne mountedWhen="visible">
        {nodeNames.map((nodeName) => (
          <primitive object={nodes[nodeName]} key={nodeName} />
        ))}
      </MountWithEbbne>

      <MountWithEbbne>
        <SetCameraTarget settingsObject={nodes[`CameraTarget_${nodeNames[0]}`]} />

        <UIPortal>
          <SideBar key={`Sidebar_${ebbneId}`} contentId={ebbneId} />
        </UIPortal>

        <WeldacMeasurementLines node={nodes[`Measurements_${nodeNames[0]}`]} />
      </MountWithEbbne>
    </>
  );
};
